import type { ReactNode } from "react";

/** A step's small capitalised band heading — notes, attachments. */
export function SectionHeading({ children }: { children: ReactNode }) {
  return (
    <h3 className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
      {children}
    </h3>
  );
}
